/* Copyright (c) 2026 Xperi. All Rights Reserved. */

import type { TivoPayloadAction } from '../../core/tivo/tivo-redux-wrapper';
import {
    CLEAR_LAST_FOCUSED_PICKER_STATE,
    RESET_SEASON_PICKER_STATE,
    SET_LAST_FOCUSED_PICKER_STATE,
    SET_SEASON_PICKER_HIGHLIGHT,
    UPDATE_SEASON_PICKER_IN_FOCUS,
} from './seasonpicker.types';

export const setSeasonPickerHorizontalHighlightAction = ({
    pickerId,
    index,
}): TivoPayloadAction<{ pickerId: string; index: number }> => ({
    type: SET_SEASON_PICKER_HIGHLIGHT,
    payload: { pickerId, index },
});

export const setSeasonPickerInFocusAction = ({
    pickerId,
    isFocused,
}): TivoPayloadAction<{ pickerId: string; isFocused: boolean }> => ({
    type: UPDATE_SEASON_PICKER_IN_FOCUS,
    payload: { pickerId, isFocused },
});

export const resetSeasonPickerStateAction = (): TivoPayloadAction<null> => ({
    type: RESET_SEASON_PICKER_STATE,
    payload: null,
});

export const setLastFocusedPickerStateAction = ({
    seasonTitle,
    pickerIndex,
    headerPosition,
}): TivoPayloadAction<{ seasonTitle: string; pickerIndex: number; headerPosition: number }> => ({
    type: SET_LAST_FOCUSED_PICKER_STATE,
    payload: { seasonTitle, pickerIndex, headerPosition },
});

export const clearLastFocusedPickerStateAction = (): TivoPayloadAction<null> => ({
    type: CLEAR_LAST_FOCUSED_PICKER_STATE,
    payload: null,
});
